import React from 'react';
import {
    Box, Button,
    CircularProgress, Dialog, DialogContent, DialogTitle,
    IconButton, LinearProgress, Slider, TextField,
    Typography
} from "@mui/material";
import Paper from "@mui/material/Paper";
import Map, {Popup, Source, Layer} from 'react-map-gl/mapbox';

import 'mapbox-gl/dist/mapbox-gl.css';

import PauseIcon from '@mui/icons-material/Pause';
import PlayCircleFilledWhiteIcon from '@mui/icons-material/PlayCircleFilledWhite';
import dayjs from 'dayjs';
import ApiCtrl from "../../svc/ApiCtrl";

import * as turf from "@turf/turf";
import {MAPBOX_TOKEN} from "./MapBlaster";
import {useDropzone} from "react-dropzone";


export default function UploadDialog({open, setOpen}) {

    const [regionName, setRegionName] = React.useState("");
    const packetSize = 1000000;
    const [currentPacket, setCurrentPacket] = React.useState(null);
    const [videoLength, setVideoLength] = React.useState(null);

    const [startUpload, setStartUpload] = React.useState(false);

    const [file, setFile] = React.useState(null);

    const onDrop = React.useCallback((acceptedFiles) => {
        setFile(acceptedFiles);
    }, [])

    const {getRootProps, getInputProps, isDragActive} = useDropzone({
        onDrop,
        maxFiles: 1,
        accept: {
            "application/x-netcdf": ["*.nc"],
        }
    })
    React.useEffect(() => {
        if (!open) {
            setFile(null);
            setRegionName("");
        }
    }, [open])

    React.useEffect(() => {
        if (file) {
            let splitElement = file[0].name.split("_")[0];
            setRegionName(splitElement);
        }
    }, [file])

    React.useEffect(() => {

            if (videoLength) {
                if (currentPacket !== null && currentPacket < videoLength) {
                    file.forEach((fileName) => {
                        const reader = new FileReader()
                        reader.onabort = () => console.log('file reading was aborted')
                        reader.onerror = () => console.log('file reading has failed')
                        reader.onload = () => {
                            const binaryStr = reader.result
                            let packets = binaryStr.slice(currentPacket * packetSize, (currentPacket + 1) * packetSize);
                            ApiCtrl.uploadTile(packets, (currentPacket + 1), videoLength, fileName.name,  (res) => {
                                setCurrentPacket(currentPacket + 1)
                            })

                        }
                        reader.readAsArrayBuffer(fileName)
                    })
                } else if (currentPacket !== null) {
                    setCurrentPacket(null);
                    setVideoLength(null);
                    setStartUpload(false);
                    setOpen(false);
                }
            }
        }, [videoLength, currentPacket]
    )

    function getLoading() {
        if (startUpload) {
            if (currentPacket && videoLength) {
                return (<>
                    <LinearProgress value={currentPacket / videoLength}/>
                    <Typography>{currentPacket}/{videoLength}</Typography>
                </>)
            } else {
                return (<>
                    <LinearProgress/>
                    <Typography>Reading file...</Typography>
                </>);
            }
        }
    }

    if (open) {
        return (
            <Dialog
                open={open}

                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"

            >
                <DialogTitle id="alert-dialog-title">
                    {"Upload a dataset"}
                </DialogTitle>
                {!startUpload && <DialogContent sx={{width: 500, height: 300, position: "relative"}}>
                    <Box sx={{
                        width: "100%"
                    }}>

                        <Box {...getRootProps()}
                             sx={{height: 30, borderStyle: "solid", display: "flex", justifyContent: "center", p: 5}}>
                            <input {...getInputProps()} />
                            {
                                isDragActive ?
                                    <Typography>Drop file here</Typography> :
                                    <Typography>Click or Drop file here</Typography>
                            }
                        </Box>
                        {file && <Box
                            sx={{display: "flex", width: "100%", p: 2, alignItems: "center", justifyContent: "center"}}>
                            <Typography>
                                File :&nbsp;
                            </Typography>
                            <Typography>{file[0].name} ✅</Typography>

                        </Box>}
                        {file && <Box sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "100%",
                            mb: 1
                        }}>
                            <Typography>Region Name</Typography>
                            <TextField value={regionName} onChange={(e) => {
                                setRegionName(e.target.value)
                            }}/>
                        </Box>}
                    </Box>

                    <Box sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        position: "absolute",
                        bottom: 5
                    }}>

                        <Button onClick={() => {
                            setOpen(false);
                        }}>Cancel</Button>
                        <Button
                            disabled={file === null}
                            onClick={() => {
                                setStartUpload(true);
                                setCurrentPacket(0)
                                file.forEach((fileName) => {
                                    const reader = new FileReader()
                                    reader.onabort = () => console.log('file reading was aborted')
                                    reader.onerror = () => console.log('file reading has failed')
                                    reader.onload = () => {
                                        const binaryStr = reader.result
                                        const nb = Math.ceil(binaryStr.byteLength / packetSize);
                                        setVideoLength(nb);

                                    }
                                reader.readAsArrayBuffer(fileName)
                                })
                            }}> Send</Button>
                    </Box>
                </DialogContent>}

                {startUpload && <DialogContent sx={{width: 500, height: 300, position: "relative"}}>
                    {getLoading()}

                    <Box sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        position: "absolute",
                        bottom: 5
                    }}>

                        <Button onClick={() => {
                            setStartUpload(false);
                            setOpen(false);
                        }}>Cancel</Button>
                    </Box>
                </DialogContent>}

            </Dialog>
        )
    }
}
